import React, { useState, useEffect } from 'react'
import { GrView } from 'react-icons/gr'
import { BsFillEyeSlashFill } from 'react-icons/bs'
import {
  AccessTemoignage,
  LoadAllTemoignage,
  StopTemoignage
} from '../../../actions/Temoignages/TemoignageAction'
import AllRoutes from '../../../nametitle/AllRoutes'
import { Localvalue } from '../../../nametitle/localValue'
import LoaderBootStrap from '../../../components/admin/dasboard/LoaderBootStrap'
import { LoadAllComment } from '../../../actions/Comments/CommentAction'

const ListCommentPage = () => {
  const items = [1, 1, 1, 1, 1, 1, 1, 1]
  const description = `
  Les formes anciennes du Moyen Âge désignent au xiie siècle le volume qui contient le texte sacré des Évangiles, puis au xiiie siècle, le texte original d'un livre saint ou des propos de quelqu'un. Au xviie siècle le mot s’applique au passage d'un ouvrage pris comme référence et au début du xixe siècle le mot texte a son sens général d'« écrit »6.
  `
  const [CommentList, setCommentList] = useState([]);
  const [CommentListSearch, setCommentListSearch] = useState([]);
  useEffect(() => {
    LoadAllComment(setCommentList, setCommentListSearch);
  }, []);

  return (
    <div class='w-full flex flex-col justify-center  rounded-lg bg-white rounded-lg '>
      <div class='w-full flex flex-col space-x-2 pr-2 mt-5'>
        {/* <div><img src={bgImg} className="translatable h-[50%] w-[50%] rounded-[50%]"/></div> */}
        <div className="translatable bg-lime-700 "><h2 className="translatable py-2 text-center text-white ">Listes des commentaires</h2></div>

        <div class='w-full flex justify-between py-3 '>
          {/* Barre de recherche */}
          <div class='input-group rounded-lg w-[400px]'>
            <input
              type='text'
              class='form-control  w-full'
              placeholder='rechercher...'
            />
            <button class='btn btn-primary px-4'>
              <i class='bi bi-search'></i>
            </button>
          </div>
          {/* Lien Ajouter */}
          {
            /*
             <a href={`/${AllRoutes.admin}/${AllRoutes.temoins}/${AllRoutes.add}`}>
              <button type='btn' class=' btn btn-primary px-4 px-2'>
                Ajouter
              </button>
            </a> */
          }
        </div>
      </div>
      {CommentList && CommentList.length > 0 ? (
        <div class='w-full flex space-x-2 min-h-[500px] overflow-y-scroll'>
          <div class='w-full'>
            <div class='w-full bg-white '>
              <div class='w-full mt-2 overflow-x-auto'>
                <div class='w-full whitespace-nowrap'>
                  <div className="translatable w-full " >
                    <div className="translatable card-header">
                      Featured
                    </div>
                    <ul className="translatable flex flex-wrap grid gap-3 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">

                      {CommentList.map(item => {
                        return (
                          <li className="translatable list-group-item">
                            <div className="translatable card" style={{ width: "18rem" }}>
                              <div className="translatable card-body">
                                <h5 className="translatable card-title line-clamp-2">
                                  <img src={`${item.image}`} className="translatable h-[50px] w-[50px] rounded-[50%]" />
                                </h5>
                                <span className="translatable bg-lime-700">{item.typeactivite}</span>
                                <h2 className="translatable text-xl" > {item.titleSubject} </h2>
                                <p className="translatable card-text line-clamp-2 h-30">{item.content}</p>
                                <a href="#" className="translatable btn btn-primary">Go somewhere</a>
                              </div>
                            </div>
                          </li>
                        )
                      })}

                    </ul>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <LoaderBootStrap />
      )}
    </div>
  )
}

export default ListCommentPage;
